import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, cloneElement } from 'react';
import { useMergedRef } from '@mantine/hooks';
import { isElement } from '@mantine/utils';
import { useComponentDefaultProps, clsx } from '@mantine/styles';
import { usePopoverContext } from '../Popover.context.js';
import { POPOVER_ERRORS } from '../Popover.errors.js';

var _excluded = ["children", "refProp", "popupType", "shouldOverrideDefaultTargetId"];
var defaultProps = {
  refProp: 'ref',
  popupType: 'dialog',
  shouldOverrideDefaultTargetId: true
};
var PopoverTarget = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useComponentDefaultP = useComponentDefaultProps('PopoverTarget', defaultProps, props),
    children = _useComponentDefaultP.children,
    refProp = _useComponentDefaultP.refProp,
    popupType = _useComponentDefaultP.popupType,
    shouldOverrideDefaultTargetId = _useComponentDefaultP.shouldOverrideDefaultTargetId,
    others = _objectWithoutProperties(_useComponentDefaultP, _excluded);
  if (!isElement(children)) {
    throw new Error(POPOVER_ERRORS.children);
  }
  var forwardedProps = others;
  var ctx = usePopoverContext();
  var targetRef = useMergedRef(ctx.reference, children.ref, ref);
  var accessibleProps = ctx.withRoles ? {
    'aria-haspopup': popupType,
    'aria-expanded': ctx.opened,
    'aria-controls': ctx.getDropdownId(),
    id: shouldOverrideDefaultTargetId ? ctx.getTargetId() : children.props.id
  } : {};
  return /*#__PURE__*/cloneElement(children, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, forwardedProps), accessibleProps), ctx.targetProps), {}, _defineProperty({
    className: clsx(ctx.targetProps.className, forwardedProps.className, children.props.className)
  }, refProp, targetRef), !ctx.controlled ? {
    onClick: ctx.onToggle
  } : null));
});

export { PopoverTarget };
//# sourceMappingURL=PopoverTarget.js.map
